import React, { useEffect } from 'react';
import logo from './logo.svg';
import './App.css';
import { TreeView } from './components/TreeView';
import axios from 'axios';
import { environment } from './environments/environment';
axios.defaults.baseURL = environment.backendUrl
function App() {
  return (
    <div className="App">
      <TreeView />
    </div>
  );
}

export default App;
